import * as React from "react";
import OpQuotesHeadingMob from "../partials/opQuotesHeadingMob";
import OpMarketDepthTable, { IOpMarketDepthTableProps } from "../partials/opMarketDepthTable";
import OpQuotesHoldings from "../partials/opQuotesHoldings";
import "../../../../../assets/scss/components/toc/orderPlacement/opQuotes/opQuotesMob.scss";
import { useRouteMatch } from "react-router-dom";
import { IOpQuotesHeadingDskProps } from "../partials/opQuotesHeadingDsk";
import { toINR } from "../../../../service/numberFormat";

export interface IOpQuotesEquityMobProps {
	quoteData: any;
	holdingData?: any;
}

const OpQuotesEquityMob: React.FC<IOpQuotesEquityMobProps> = props => {
	const [showHoldings, setShowHoldings] = React.useState(false);
	const [showMarketDepth, setShowMarketDepth] = React.useState(false);
	const futOpt = useRouteMatch().url.split("/")[3];

	const quotesHeadingProps: IOpQuotesHeadingDskProps = {
		dpNm: props.quoteData.qt?.dpNm,
		ltp: props.quoteData.qt?.ltp,
		chLTP: props.quoteData.qt?.chg,
		chLTPPer: props.quoteData.qt?.chgP,
		exc: props.quoteData.qt?.exc,
		ltt: props.quoteData.qt?.ltt,
		expiry:
			futOpt === "future"
				? `${props.quoteData.qt?.dpExpDt} ${props.quoteData.qt?.dpInsTyp || ""}`
				: futOpt === "option"
				? `${props.quoteData.qt?.dpExpDt} ${props.quoteData.qt?.opTyp} ${props.quoteData.qt?.stkPrc}`
				: undefined
	};

	const quotesDetilsProps: IOpMarketDepthTableProps = {
		open: props.quoteData.qt?.o,
		volume: props.quoteData.qt?.vol,
		high: props.quoteData.qt?.h,
		low: props.quoteData.qt?.l,
		tBidQty: props.quoteData.mkd?.buyQty,
		tAskQty: props.quoteData.mkd?.sellQty,
		ask: props.quoteData.mkd?.ask,
		bid: props.quoteData.mkd?.bid,
		spot: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.spot : undefined,
		opInt: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.opInt : undefined,
		opIntChgP: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.opIntChgP : undefined,
		hiCt: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.hiCt : undefined,
		loCt: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.loCt : undefined,
		ltSz: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.ltSz : undefined,
		bidivfut: futOpt === "option" ? props.quoteData.qt?.bidivfut : undefined,
		mns: futOpt === "option" ? props.quoteData.qt?.mns : undefined
	};

	return (
		<section className="quotes_cont">
			<OpQuotesHeadingMob {...quotesHeadingProps} />

			<div className="quotes_cont_row m_2">
				<button className="blue_btn" onClick={() => setShowMarketDepth(true)}>
					Market Depth
				</button>

				{props.holdingData && (
					<button className="blue_btn" onClick={() => setShowHoldings(true)}>
						<i className="edel-icon-purse" /> {toINR(+props.holdingData.hdQtyCnc + +props.holdingData.hdQtyMtf)} qty
					</button>
				)}
			</div>

			{showMarketDepth && (
				<>
					<div className="popup_overlay" onClick={() => setShowMarketDepth(false)} />
					<div className="popup">
						<div className="popup_header">
							<span>Market Depth</span>
							<button className="edel-icon-close" onClick={() => setShowMarketDepth(false)} />
						</div>
						<OpMarketDepthTable {...quotesDetilsProps} />
					</div>
				</>
			)}

			{showHoldings && (
				<>
					<div className="popup_overlay" onClick={() => setShowHoldings(false)} />
					<div className="popup">
						<div className="popup_header">
							<span>Your Holdings</span>
							<button className="edel-icon-close" onClick={() => setShowHoldings(false)} />
						</div>
						<OpQuotesHoldings
							data={[
								{ label: "Total Quantity", value: toINR(+props.holdingData.hdQtyCnc + +props.holdingData.hdQtyMtf) },
								{
									label: "Total Value",
									value: `₹ ${toINR(
										(+props.holdingData.hdQtyCnc + +props.holdingData.hdQtyMtf) * props.quoteData.mkd?.ask[0].price
									)}`
								}
							]}
							hldgOrPos="holding"
						/>
					</div>
				</>
			)}
		</section>
	);
};

export default OpQuotesEquityMob;
